var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ql-editor box-shadow"},[_c('div',{staticStyle:{"padding":"30px 0","width":"45vw"},domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }